/** @format */

import { AttributeOption } from '@pdp/data-access/interfaces';

export const getSelectedAttributeValue = (
  selectedAttributeOptions: readonly AttributeOption[] | undefined,
  attributeName: string | undefined,
) => {
  if (!attributeName) return undefined;

  const attributeNameLower = attributeName.toLowerCase();

  return selectedAttributeOptions?.find(
    (attribute) => attribute?.name?.toLowerCase() === attributeNameLower,
  )?.value;
};
